module.exports = __webpack_public_path__ + "img/qr.d329a0c4.jpg";